import { render, staticRenderFns } from "./workload-dashboard.vue?vue&type=template&id=5edbf479&scoped=true&"
import script from "./workload-dashboard.vue?vue&type=script&lang=js&"
export * from "./workload-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edbf479",
  null
  
)

export default component.exports